const { cxt } = require('./context');

const email = [
  'email',
];

const emailRequired = [
  'required',
  'email',
];

module.exports = {
  email,
  emailRequired,
};
